import type { SupportedCurrencies } from '@app/utils/pricingCurrencyUtils';
import type { TableRow } from '@konnecta/generic-table';

/** One caregiver's cash-on-hand row (cash collected and owed back). */
export interface CaregiverCashRow extends TableRow {
  id: string | number;
  caregiverId: number;
  name: string;
  balance: number;
  currency: SupportedCurrencies;
  createdAt?: string | null;
}

/** A single cash transaction (collection or deposit) for a caregiver. */
export interface CaregiverCashTxRow extends TableRow {
  id: string | number;
  transactionType: string;
  transactionDate: string;
  amount: number;
  currency: SupportedCurrencies;
  notes?: string | null;
  clientName?: string | null;
  visitId?: number | null;
}

/** Default sort for the caregiver cash list (by caregiver name, ascending). */
export const DEFAULT_CAREGIVER_CASH_SORT = 'name';
